import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Tooltip, Typography } from '@mui/material';
import { CustomCard } from '../../common/Customcard';
import DrawerComponent from '../../common/DrawerComponent';
import InvoiceDrawer from './InvoiceDrawer';
import "../Finance.css"
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import { toWords } from 'number-to-words';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import CompanyDetails from './CompanyDetails';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { BASE_URL } from '../config';
import html2pdf from "html2pdf.js";
import StyledTable from '../../StyledTable';

const getBase64FromPublic = async (path) => {
    const response = await fetch(path);
    const blob = await response.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
};
const capitalizeFirst = (str) => str.charAt(0).toUpperCase() + str.slice(1);
const InvoicePage = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    console.log(selectedInvoice, "selectedInvoice")
    const [viewDialogOpen, setViewDialogOpen] = useState(false);
    const [invoices, setInvoices] = useState([]);
    const [company, setCompany] = useState(null);
    console.log(company, "company");
    const [editInvoiceId, setEditInvoiceId] = useState(null);
    const [showHiddenInvoice, setShowHiddenInvoice] = useState(false)
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false); // New state to track PDF generation

    const handleEditInvoice = (invoice) => {
        setEditInvoiceId(invoice.id);
        setDrawerOpen(true);
    };

    const handleConvertToInvoice = async (invoice) => {
        try {
            const res = await axios.put(
                `/api/invoice-credit/?invoice_id=${invoice?.id}`,
                {
                    grand_total: String(invoice?.grandTotal)   // Ensure string for Decimal()
                }
            )
            toast.success("Convert to invoice successfully!");
            fetchInvoices();
        } catch (error) {
            toast.error(
                error?.response?.data?.error
                    ? error.response.data.error
                    : "Could not convert to invoice"
            );
            console.error("Generate invoice error", error);
        }
    };

    const fetchInvoices = async () => {
        const response = await axios.get('/api/invoice/');
        const invoicesFromApi = response.data.map(apiToUiInvoice);
        setInvoices(invoicesFromApi);
    };

    useEffect(() => {
        fetchInvoices();
        fetchCompanies()
    }, []);

    const fetchCompanies = async () => {
        try {
            const response = await axios.get('/api/company-details/');
            const companyData = response.data[0];
            if (companyData) {
                setCompany(companyData);
            }
        } catch (err) {
            console.error('Fetch Error:', err);
        }
    };

    // Fixed handleDirectDownload function
    function handleDirectDownload() {
        // Check if company data is available
        // if (!company) {
        //     toast.error("Company data not loaded. Please try again.");
        //     return;
        // }
        
        // // Check if selectedInvoice is available
        // if (!selectedInvoice) {
        //     toast.error("No invoice selected. Please try again.");
        //     return;
        // }
        
        setIsGeneratingPdf(true);
        setShowHiddenInvoice(true);
        
        // Use a longer timeout and add a retry mechanism
        const findElementAndGeneratePdf = (retryCount = 0) => {
            const element = document.getElementById("invoice-preview-pdf");
            
            if (!element) {
                if (retryCount < 3) {
                    // Retry after 500ms
                    setTimeout(() => findElementAndGeneratePdf(retryCount + 1), 500);
                } else {
                    toast.error("No invoice content found!");
                    setShowHiddenInvoice(false);
                    setIsGeneratingPdf(false);
                }
                return;
            }
            
            const opt = {
                margin: [10, 10, 10, 10],
                filename: `Invoice_${selectedInvoice?.invoiceNo || "preview"}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
            };
            
            html2pdf()
                .set(opt)
                .from(element)
                .save()
                .then(() => {
                    setShowHiddenInvoice(false);
                    setIsGeneratingPdf(false);
                })
                .catch(error => {
                    console.error("PDF generation error:", error);
                    toast.error("Failed to generate PDF");
                    setShowHiddenInvoice(false);
                    setIsGeneratingPdf(false);
                });
        };
        
        // Initial attempt after 1000ms
        setTimeout(() => findElementAndGeneratePdf(), 1000);
    }

    function apiToUiInvoice(api) {
        console.log("api", api)
        return {
            invoiceNo: api.invoice_no,
            buyerName: api.buyer_name,
            mobile: api.mobile,
            email: api.email,
            address: api.address,
            productId: api.product_id,
            product: api.product,
            paymentTerm: api.payment_term,
            date: api.date,
            descriptions: api.descriptions,
            grandTotal: api.grand_total,
            id: api.id,
            created_at: api.created_at,
            bill_generated: api.bill_generated,
            condition: api.condition,
            single_entry: api.single_entry,
        };
    }

    const handleSaveInvoice = async (invoiceData, editId = null) => {
        try {
            if (editId) {
                await axios.put(`/api/invoice/?id=${editId}`, invoiceData);
                toast.success("Invoice updated successfully!");
            } else {
                await axios.post("/api/invoice/", invoiceData);
                toast.success("Invoice added successfully!");
            }

            fetchInvoices();
            setDrawerOpen(false);
            setEditInvoiceId(null);
        } catch (err) {
            console.error("Failed to save invoice:", err);
            toast.error("Failed to save invoice.");
        }
    };
// Add this new function to handle the button click
const handleDownloadClick = (row) => {
    // Prevent multiple clicks if a PDF is already being generated
    if (isGeneratingPdf) {
        return;
    }
    setSelectedInvoice(row);
    setShowHiddenInvoice(true);
};
// Add this useEffect hook in your component
useEffect(() => {
    // Only proceed if all required data is available and the preview should be shown
    if (selectedInvoice && company && showHiddenInvoice) {
        // Set a small timeout to ensure the DOM element has been rendered by React
        const timer = setTimeout(() => {
            const element = document.getElementById("invoice-preview-pdf");
            
            if (!element) {
                toast.error("No invoice content found! Please try again.");
                setShowHiddenInvoice(false);
                return;
            }

            const opt = {
                margin: [10, 10, 10, 10],
                filename: `Invoice_${selectedInvoice?.invoiceNo || "preview"}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
            };
            
            setIsGeneratingPdf(true); // Set generating state to disable the button

            html2pdf()
                .set(opt)
                .from(element)
                .save()
                .then(() => {
                    // Success
                    setShowHiddenInvoice(false);
                })
                .catch(error => {
                    console.error("PDF generation error:", error);
                    toast.error("Failed to generate PDF.");
                    setShowHiddenInvoice(false);
                })
                .finally(() => {
                    // This runs on both success and failure
                    setIsGeneratingPdf(false);
                });
        }, 500); // Small timeout for DOM rendering

        // Cleanup function: clear the timeout if the component unmounts or dependencies change
        return () => clearTimeout(timer);
    }
}, [selectedInvoice, company, showHiddenInvoice]); // This effect runs when these states change
    const handleDownloadExcel = async (id) => {
        console.log(id, "res");

        try {
            const res = await axios.get(`/api/download/invoice/?id=${id}`, {
                responseType: 'blob',
            });

            const blob = new Blob([res.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', `invoice_${new Date().toISOString().slice(0, 10)}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download Excel failed:", error);
        }
    };

    const columns = [
        { field: 'sno', headerName: 'S.No', width: '5%' },
        { field: 'date', headerName: 'Date', width: '10%' },
        { field: 'invoiceNo', headerName: 'Invoice No', width: '15%' },
        {
            field: "product", headerName: "Product / Service Name", flex: 1,
            renderCell: (params) => {
                const { product } = params.row;
                return (
                    <Box display="flex" flexDirection="column" width="100%" className="hide-scrollbar" sx={{ maxHeight: 80, overflowY: "auto", overflowX: "hidden", p: 1 }}>
                        <Typography variant="small" sx={{ fontWeight: 500, color: "#333", whiteSpace: "normal", wordBreak: "break-word", textOverflow: "ellipsis", p: 1 }}>
                            {product?.product_name}
                        </Typography>
                    </Box>
                );
            },
        },
        { field: 'buyerName', headerName: 'Buyer Name', width: '20%' },
        { field: 'mobile', headerName: 'Mobile', width: '15%' },
        { field: 'email', headerName: 'Email', width: '20%' },
        { field: 'grandTotal', headerName: 'Grand Total', width: '15%' },
        {
            field: "actions",
            headerName: "Actions",
            width: 150,
            sortable: false,
            renderCell: ({ row }) => (
                <Box display="flex" justifyContent="center" alignItems="center" sx={{ gap: 0.5 }}>
                    {console.log(row, "row")}
                    {!row.bill_generated && (
                        <>
                            <Tooltip title="Edit Invoice" arrow>
                                <IconButton
                                    size="small"
                                    color="info"
                                    onClick={() => handleEditInvoice(row)}
                                >
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Convert to Invoice" arrow>
                                <IconButton
                                    size="small"
                                    color="success"
                                    onClick={() => handleConvertToInvoice(row)}
                                >
                                    <ReceiptOutlinedIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </>
                    )}

                    {/* Always allow download for both cases */}
                    <Tooltip title="Download PDF" arrow>
                        <IconButton
                            size="small"
                            color="secondary"
                            onClick={() => {
                                setSelectedInvoice(row);
                                // Use a callback to ensure selectedInvoice is set before calling handleDirectDownload
                                setTimeout(() => {
                                    handleDirectDownload();
                                }, 500);
                            }}
                            disabled={isGeneratingPdf} // Disable while generating PDF
                        >
                            <PictureAsPdfIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Download Excel" arrow>
                        <IconButton
                            size="small"
                            onClick={() => handleDownloadExcel(row.id)}
                        >
                            <img
                                src="https://img.icons8.com/color/24/microsoft-excel-2019--v1.png"
                                alt="Excel Icon"
                                style={{ width: 20, height: 20 }}
                            />
                        </IconButton>
                    </Tooltip>
                </Box>
            )
        }
    ];
    
    function capitalizeWords(str) {
        return str.replace(/\b\w/g, (char) => char.toUpperCase());
    }

    // Fixed HiddenInvoicePreview component with null checks
    const HiddenInvoicePreview = () => {
        // Don't render if company or selectedInvoice is null
        if (!company || !selectedInvoice) {
            return null;
        }
        
        return (
            <div
                style={{
                    position: "absolute",
                    left: "-9999px",
                    top: 0,
                    height: 0,
                    overflow: "hidden",
                    pointerEvents: "none"
                }}
            >
                <div
                    id="invoice-preview-pdf"
                    style={{
                        backgroundColor: "#fff",
                        fontFamily: "Arial, sans-serif",
                        maxWidth: 800,
                        margin: "0 auto",
                        border: "1px solid #000",
                        borderRadius: 1,
                        boxSizing: "border-box",
                    }}
                >
                    {/* 1st Row */}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            borderBottom: "1px solid #000"
                        }}
                    >
                        {/* 1st Column - Company details with border */}
                        <div
                            style={{
                                flex: "1 1 350px",
                                minWidth: 0,
                                padding: 5,
                                textAlign: "center",
                                borderRight: "1px solid #000"
                            }}
                        >
                            {company?.logo && (
                                <div
                                    style={{
                                        maxWidth: 180,
                                        maxHeight: 60,
                                        overflow: "hidden",
                                        marginBottom: 8,
                                        marginLeft: "20%"
                                    }}
                                >
                                    <img
                                        src={`${BASE_URL}${company.logo}`}
                                        alt={`${company.name} logo`}
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            display: "block",
                                        }}
                                    />
                                </div>
                            )}
                            <Typography variant="subtitle1" fontWeight="bold" noWrap={false}>
                                {company?.name}
                            </Typography>
                            <Typography style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                                {company?.address}
                            </Typography>
                            <Typography>
                                {company?.city}, {company?.state}
                            </Typography>
                            <Typography>Email: {company?.email}</Typography>
                            <Typography>Phone: {company?.phone}</Typography>
                            <Typography>GST Number: {company?.gst_number}</Typography>
                        </div>

                        {/* 2nd Column */}
                        <div
                            style={{
                                flex: "1 1 350px",
                                display: "flex",
                                flexDirection: "column",
                                minWidth: 0,
                            }}
                        >
                            {/* 1st Row inside 2nd column (Invoice No, Date) */}
                            <div
                                style={{
                                    display: "flex",
                                    borderBottom: "1px solid #000",
                                    height: "45%",
                                }}
                            >
                                <div
                                    style={{
                                        flex: 1,
                                        padding: 12,
                                        minWidth: 0,
                                        borderRight: "1px solid #000",
                                        justifyItems: "center",
                                        alignItems: "center",
                                        height: "100%",
                                    }}
                                >
                                    <Typography variant="subtitle2" fontWeight="bold">
                                        Invoice No:
                                    </Typography>
                                    <Typography>{selectedInvoice.invoiceNo}</Typography>
                                </div>

                                <div
                                    style={{
                                        flex: 1,
                                        padding: 12,
                                        minWidth: 0,
                                        justifyItems: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <Typography variant="subtitle2" fontWeight="bold">
                                        Date:
                                    </Typography>
                                    <Typography>{selectedInvoice.created_at || selectedInvoice.date}</Typography>
                                </div>
                            </div>

                            {/* 2nd Row inside 2nd column (Mode/Terms of Payment) */}
                            <div
                                style={{
                                    padding: 12,
                                    minWidth: 0,
                                    display: "flex",
                                    flexWrap: "wrap"
                                }}
                            >
                                <Typography variant="subtitle2" fontWeight="bold">
                                    Mode/Terms of Payment:
                                </Typography>
                                <Typography>{`${selectedInvoice.paymentTerm} Immediate, Balance on Deployment`}</Typography>
                            </div>
                        </div>
                    </div>

                    {/* 2nd Row (Bill To and Product) */}
                    <div
                        style={{
                            display: "flex",
                            borderBottom: "1px solid #000",
                            flexDirection: "row",
                        }}
                    >
                        {/* Bill To */}
                        <div
                            style={{
                                flex: "1 1 350px",
                                padding: 12,
                                minWidth: 0,
                                textAlign: "center",
                                borderRight: "1px solid #000",
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                            }}
                        >
                            <Typography>Buyer: {selectedInvoice.buyerName} </Typography>
                        </div>

                        {/* Product */}
                        <div
                            style={{
                                flex: "1 1 350px",
                                padding: 12,
                                minWidth: 0,
                                textAlign: "right",
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                            }}
                        >
                            <Typography>{selectedInvoice?.product?.category}</Typography>
                            <Typography> - </Typography>
                            <Typography>{selectedInvoice?.product?.name}</Typography>
                        </div>
                    </div>

                    {/* Invoice Items Table */}
                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                        }}
                    >
                        <thead>
                            <tr style={{
                                borderBottom: "1px solid #000",
                            }}>
                                <th
                                    style={{
                                        textAlign: "left",
                                        padding: 8,
                                        borderRight: "1px solid #000",
                                    }}
                                >
                                    Sl.No
                                </th>
                                <th
                                    style={{
                                        textAlign: "left",
                                        padding: 8,
                                        borderRight: "1px solid #000",
                                    }}
                                >
                                    Description
                                </th>
                                <th
                                    style={{
                                        textAlign: "right",
                                        padding: 8,
                                    }}
                                >
                                    Amount (₹)
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedInvoice.descriptions.map((item, index) => (
                                <tr
                                    key={index}
                                    style={{ borderBottom: "1px solid #000" }}
                                >
                                    <td style={{ borderRight: "1px solid #000", padding: 8 }}>{index + 1}</td>
                                    <td style={{ borderRight: "1px solid #000", padding: 8 }}>{item.text}</td>
                                    <td style={{ padding: 8, textAlign: "right" }}>
                                        {Number(item.amount) === 0 ? "" : `₹${Number(item.amount).toFixed(2)}`}
                                    </td>
                                </tr>
                            ))}

                            {/* Add this row after the map */}
                            <tr style={{
                                borderBottom: "1px solid #000",
                            }}>
                                <td style={{ borderRight: "1px solid #000", padding: 8 }}></td>
                                <td style={{ borderRight: "1px solid #000", padding: 8, fontWeight: "bold", textAlign: "center" }}>
                                    {selectedInvoice.condition}
                                </td>
                                <td style={{ padding: 8 }}></td>
                            </tr>
                        </tbody>

                        <tfoot>
                            {(() => {
                                const total = selectedInvoice.descriptions.reduce(
                                    (sum, item) => sum + Number(item.amount),
                                    0
                                );
                                const gstPercentage = Number(selectedInvoice?.product?.gst_percentage) || 0;
                                const gstAmount = (total * gstPercentage) / 100;
                                const grandTotal = total + gstAmount;

                                return (
                                    <>
                                        <tr>
                                            <td style={{ borderRight: "1px solid #000", }}></td>
                                            <td
                                                style={{
                                                    fontWeight: "bold",
                                                    padding: 8,
                                                    borderRight: "1px solid #000",
                                                    textAlign: "left",
                                                    borderBottom: "1px solid #000"
                                                }}
                                            >
                                                Total
                                            </td>
                                            <td
                                                style={{
                                                    fontWeight: "bold",
                                                    padding: 8,
                                                    textAlign: "right",
                                                    borderBottom: "1px solid #000"
                                                }}
                                            >
                                                {selectedInvoice.single_entry === true
                                                    ? `₹${selectedInvoice.grandTotal}`
                                                    : `₹${total.toFixed(2)}`}

                                            </td>
                                        </tr>
                                        <tr >
                                            <td style={{ borderRight: "1px solid #000", }}></td>
                                            <td
                                                style={{
                                                    fontWeight: "bold",
                                                    padding: 8,
                                                    borderRight: "1px solid #000",
                                                    textAlign: "left",
                                                    borderBottom: "1px solid #000"
                                                }}
                                            >
                                                GST ({gstPercentage}%)
                                            </td>
                                            <td
                                                style={{
                                                    fontWeight: "bold",
                                                    padding: 8,
                                                    textAlign: "right",
                                                    borderBottom: "1px solid #000"
                                                }}
                                            >
                                                {selectedInvoice.single_entry === true
                                                    ? `₹${(selectedInvoice.grandTotal * gstPercentage) / 100}`
                                                    : `₹${gstAmount.toFixed(2)}`}
                                            </td>
                                        </tr>
                                        <tr style={{ borderBottom: "1px solid #000" }}>
                                            <td style={{ borderRight: "1px solid #000", }}></td>
                                            <td
                                                style={{
                                                    fontWeight: "bold",
                                                    padding: 8,
                                                    borderRight: "1px solid #000",
                                                    textAlign: "center",

                                                }}
                                            >
                                                Grand Total
                                            </td>
                                            <td
                                                style={{
                                                    fontWeight: "bold",
                                                    padding: 8,
                                                    textAlign: "right",
                                                }}
                                            >
                                                {selectedInvoice.single_entry === true
                                                    ? `₹${(Number(selectedInvoice.grandTotal) + (Number(selectedInvoice.grandTotal) * gstPercentage) / 100).toFixed(2)}`
                                                    : `₹${grandTotal.toFixed(2)}`
                                                }

                                            </td>
                                        </tr>
                                    </>
                                );
                            })()}
                        </tfoot>
                    </table>

                    {/* Amount chargeable in words */}
                    <Typography style={{ margin: 12, }}>
                        <strong>
                            Amount chargeable (in words) –
                            {selectedInvoice.single_entry === true
                                ? `${capitalizeWords(
                                    toWords(
                                        Math.round(
                                            Number(selectedInvoice.grandTotal) +
                                            (Number(selectedInvoice.grandTotal) *
                                                (Number(selectedInvoice?.product?.gst_percentage) || 0)) /
                                            100
                                        )
                                    )
                                )} only`
                                : `${capitalizeWords(
                                    toWords(
                                        Math.round(
                                            selectedInvoice.descriptions.reduce(
                                                (sum, item) => sum + Number(item.amount),
                                                0
                                            ) *
                                            (1 + (Number(selectedInvoice?.product?.gst_percentage) || 0) / 100)
                                        )
                                    )
                                )} only`}
                        </strong>
                    </Typography>
                    
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", borderBottom: "1px solid #000" }}>
                        <div style={{ padding: 10, marginLeft: "8%" }}>
                            {/* Bank Details Section */}
                            <Typography variant="h6" style={{ marginBottom: 10, marginLeft: 20 }}>
                                Bank Details
                            </Typography>

                            <Typography>
                                <strong>Bank Name:</strong> {company?.bank_name || "N/A"}
                            </Typography>

                            <Typography>
                                <strong>Account Number:</strong> {company?.account_number || "N/A"}
                            </Typography>

                            <Typography>
                                <strong>IFSC Code:</strong> {company?.ifsc_code || "N/A"}
                            </Typography>
                        </div>

                        {/* Signature and authorized signatory */}
                        <div style={{
                            textAlign: "center", marginTop: 10, padding: 5, borderTop: "1px solid #000",
                            borderLeft: "1px solid #000"
                        }}>
                            <Typography> For {company?.name || "Company"}</Typography>
                            {company?.signature && (
                                <img
                                    src={`${BASE_URL}${company.signature}`}
                                    alt="Authorized signature"
                                    style={{ maxHeight: 80, marginTop: 8, marginBottom: 8, marginRight: 10 }}
                                />
                            )}
                            <Typography>Authorized Signatory</Typography>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div style={{
            position: "relative",
        }}>
            <div className="header-actions">
                <Button variant="contained" color="primary" onClick={() => setDrawerOpen(true)}>
                    + Add Invoice
                </Button>
            </div>

            <StyledTable columns={columns} data={invoices} itemsPerPage={4} />

            <DrawerComponent open={drawerOpen} onClose={() => {
                setDrawerOpen(false);
                setEditInvoiceId(null);
            }} title={editInvoiceId ? "Edit Invoice" : "Create Invoice"}>
                <InvoiceDrawer
                    onSave={handleSaveInvoice}
                    editId={editInvoiceId}
                />
            </DrawerComponent>

            <Toaster position="top-right" />
            {showHiddenInvoice && <HiddenInvoicePreview />}
        </div>
    );
};

export default InvoicePage;